import React from "react"
import PropTypes from "prop-types"
import { FieldArray, reduxForm } from "redux-form"

import Items from "./items"
import ErrorFields from "./error-fields"

class Form extends React.Component {
  render() {
    const { currentValues, onRevert, errors, submitDisabled, handleSubmit, 
      pristine, reservationId, defaultDate, onEdit } = this.props
    const itemValues = currentValues ? currentValues.items : []
    const itemsProps = { currentValues: itemValues, reservationId, defaultDate, onEdit }

    return (
      <form onSubmit={handleSubmit}>
        <FieldArray name="items" component={Items} props={itemsProps} />
        <ErrorFields errors={errors} />
        {!pristine &&
          <div className="edit-recurrings__footer">
            <button disabled={submitDisabled} className="btn btn-default" type="button" onClick={onRevert} >
              Revert
            </button>
            <button disabled={submitDisabled} className="btn btn-info" type="submit">
              Confirm
            </button>
          </div>
        }
      </form>
    )
  }
}

Form.propTypes = {
  currentValues: PropTypes.object,
  errors: PropTypes.object,
  submitDisabled: PropTypes.bool,
  pristine: PropTypes.bool,
  reservationId: PropTypes.number,
  defaultDate: PropTypes.string,
  onEdit: PropTypes.func,
  onRevert: PropTypes.func,
  handleSubmit: PropTypes.func,
}

export default reduxForm({form: "recurring-reservations", enableReinitialize: true})(Form)
